import { render, staticRenderFns } from "./comp_FooterSocialItem.vue?vue&type=template&id=7ce99cc2&scoped=true&"
import script from "./comp_FooterSocialItem.vue?vue&type=script&lang=js&"
export * from "./comp_FooterSocialItem.vue?vue&type=script&lang=js&"
import style0 from "./comp_FooterSocialItem.vue?vue&type=style&index=0&id=7ce99cc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce99cc2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
